import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";


const imageGalleryCarousel = document.querySelectorAll('.js-fw-carousel');

 for (const imgSlider of imageGalleryCarousel) {
    const sliderPagination = imgSlider.querySelector('.fw-carousel__counter');
    const swipePrev        = imgSlider.querySelector('.fw-carousel__button--prev');
    const swipeNext        = imgSlider.querySelector('.fw-carousel__button--next');
    const imageWrapper     = imgSlider.querySelector('.fw-carousel__wrap');

    new Swiper(imageWrapper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.5,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: sliderPagination,
        type: 'fraction',
      }, 
      navigation: {
        nextEl: swipeNext,
        prevEl: swipePrev,
      },
      breakpoints: {
        576: {
            spaceBetween: 30
        },
        1200: {
            slidesPerView: 2.5
        }
      }
    });
}
